import { ViteReactSSG } from 'vite-react-ssg'

import { routes } from './routes'
import './styles.css'

// vite-react-ssg owns the router and the HelmetProvider. It pre-renders every
// static route at build time and hydrates the same tree on the client.
export const createRoot = ViteReactSSG({ routes })
